import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurMotion,
    getPurpurSpacing,
    getPurpurTypography,
} from '@telialt/common-theme/src/purpurSelectors';

export const Unavailable = styled.p`
    display: none;
`;

export const Diagonal = styled.span`
    position: absolute;
    inset: calc(-1 * ${getPurpurBorder('widthXs')});
    overflow: hidden;

    &::after {
        content: '';
        position: absolute;
        top: -50%;
        left: 50%;
        width: 1px;
        height: 200%;
        background: ${getPurpurColor('textInteractivePrimary')};
        transform: rotate(-57.3deg) translateX(-50%);
        transform-origin: center;
        transition: background ${getPurpurMotion('duration100')} ease;
    }
`;

export const CapsuleShapedRadio = styled.div`
    display: inline-block;
    position: relative;

    label {
        position: relative;
        display: inline-flex;
        align-items: center;
        user-select: none;
        cursor: pointer;
        padding: calc(0.625rem - ${getPurpurBorder('widthXs')})
            calc(${getPurpurSpacing('200')} - ${getPurpurBorder('widthXs')});
        border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderInteractivePrimary')};
        border-radius: ${getPurpurBorder('radiusMd')};
        background: ${getPurpurColor('functionalTransparent')};
        color: ${getPurpurColor('textInteractivePrimary')};
        font-family: ${getPurpurTypography('familyDefault')}, Helvetica, Arial, 'Lucida Grande', sans-serif;
        font-size: ${getPurpurTypography('scale100')};
        line-height: ${getPurpurTypography('lineHeightLoose')};
        font-weight: ${getPurpurTypography('weightNormal')};
        transition:
            background ${getPurpurMotion('duration100')} ease,
            color ${getPurpurMotion('duration100')} ease,
            border-color ${getPurpurMotion('duration100')} ease;

        &:hover {
            border-color: ${getPurpurColor('borderInteractivePrimaryHover')};
            background: ${getPurpurColor('backgroundInteractiveTransparentHover')};
            color: ${getPurpurColor('textInteractivePrimaryHover')};
        }
        &:active {
            border-color: ${getPurpurColor('borderInteractivePrimaryActive')};
            background: ${getPurpurColor('backgroundInteractiveTransparentActive')};
            color: ${getPurpurColor('textInteractivePrimaryActive')};
        }

        &:hover::after {
            content: '';
            position: absolute;
            top: -${getPurpurBorder('widthXs')};
            bottom: -${getPurpurBorder('widthXs')};
            left: -${getPurpurBorder('widthXs')};
            right: -${getPurpurBorder('widthXs')};
            border: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('borderInteractivePrimaryHover')};
            border-radius: ${getPurpurBorder('radiusMd')};
        }
    }

    input {
        opacity: 0;
        position: absolute;
        inset: 0;
        margin: 0;
    }
    input:checked {
        ~ label {
            border-color: transparent;
            background: ${getPurpurColor('backgroundInteractivePrimary')};
            color: ${getPurpurColor('textInteractiveOnPrimary')};
            font-weight: ${getPurpurTypography('weightMedium')};
            &:hover {
                background: ${getPurpurColor('backgroundInteractivePrimaryHover')};
            }
            &:active {
                background: ${getPurpurColor('backgroundInteractivePrimaryActive')};
            }
            ${Diagonal}::after {
                background: ${getPurpurColor('textInteractiveOnPrimary')};
            }
        }
    }
    input:disabled {
        ~ label {
            border-color: ${getPurpurColor('borderMedium')};
            color: ${getPurpurColor('textWeak')};
            cursor: not-allowed;

            &:hover {
                border-width: ${getPurpurBorder('widthXs')};
                padding: calc(0.625rem - ${getPurpurBorder('widthXs')})
                    calc(${getPurpurSpacing('200')} - ${getPurpurBorder('widthXs')});
                background: ${getPurpurColor('backgroundInteractiveTransparentHover')};
            }
            ${Diagonal}::after {
                background: ${getPurpurColor('borderMedium')};
            }
        }
    }
    input:disabled:checked {
        ~ label {
            border-color: transparent;
            background: ${getPurpurColor('backgroundInteractiveDisabled')};
            color: ${getPurpurColor('textWeak')};
            &:hover {
            }
        }
    }

    input:focus:not(:focus-visible) {
        outline: 0;
    }
    input:focus:focus-visible ~ label::after {
        content: '';
        position: absolute;
        inset: calc(-1 * calc((${getPurpurBorder('widthSm')} * 2) + ${getPurpurBorder('widthXs')}));
        border-radius: ${getPurpurSpacing('150')};
        border: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('borderInteractiveFocus')};
    }
`;
